import { render, staticRenderFns } from "./register.component.vue?vue&type=template&id=72875ec2&scoped=true"
import script from "./register.component.vue?vue&type=script&lang=js"
export * from "./register.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72875ec2",
  null
  
)

export default component.exports